import axios from 'axios'
import base from '@/api/base.api';
const namespace = 'pagando-config';

export default {
    getBusinessConfig: (myOrg = false, onSuccess, onError) => {
        return axios.post(`${base.baseUrl}/${namespace}/get-business-config`, {myOrg})
            .then(onSuccess)
            .catch(onError);
    }
}
